import { QFilterGeneric } from './QFilterGeneric'

export class QFilterDateRange extends QFilterGeneric {
  name = "date_range";
  class_name = "QFilterDateRange";
  api_name = 'date_range';
  chip_component = 'ChipDateRange';
  
  serialize(qfilters) {
    return encodeURIComponent(this.value);
  }
}
